import Modal from 'react-bootstrap/Modal';
import AddAccountBlock from '../AddAccountBlock/AddAccountBlock';
import closeIcon from '../../../images/black-close-icon.svg';
import * as Styled from './AddAccountModalStyles';

interface AddAccountModalProps {
  platformName: string;
  isShowAddAccount: boolean;
  setShowAddAccount: Function;
  dataMultipleAccs: Array<any> | undefined;
  service: object | any;
  icon: string;
  onAdd: Function;
  showAddNew: boolean;
}

const AddAccountModal = ({
  platformName,
  service,
  isShowAddAccount,
  setShowAddAccount,
  dataMultipleAccs,
  icon,
  onAdd,
}:AddAccountModalProps) => {
  return (
    <Modal 
        show={isShowAddAccount} 
        onHide={()=>setShowAddAccount(false)}
        animation={false}
        centered
        size='lg'
        contentClassName='addaccount-modal'
      >
        <Styled.StyledModalBody >
          <Styled.Container className='CloseIcon'
            onClick={()=>setShowAddAccount(false)}
          >
            <Styled.StyledImg src={closeIcon} />
          </Styled.Container>
          <Styled.Container className='DataMultipleAccs'>
            {
              dataMultipleAccs && dataMultipleAccs.map( (e, i) => {
                return <AddAccountBlock key={i} item={e}
                          platformName={platformName} icon={icon}
                       />;
              })
            }
            {/*{
              showAddNew &&
              <AddAccountBlock addNew={true} platformName={platformName} icon={icon}
                               loginLink={service.connectionLink || '#'}
              />
            }*/}
          </Styled.Container>
        </Styled.StyledModalBody>
      <Styled.StyledModalFooter>
        <Styled.StyledModalBtn
          variant='primary'
          className='LoginLink'
          onClick={onAdd}
        >
          Add Account
        </Styled.StyledModalBtn>
      </Styled.StyledModalFooter>
      </Modal>
  );
}

export default AddAccountModal;